import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">&copy; {new Date().getFullYear()} LocalBranding Pro. All rights reserved.</p>
          <div className="flex flex-col items-center md:items-end gap-1">
            <p className="text-sm text-slate-500">A <a href="https://web-techservices.com" className="text-slate-400 hover:text-white transition-colors">Web-TechServices AI</a> product.</p>
            <Link to="/admin/login" className="text-slate-600 hover:text-slate-400 text-[11px] transition-colors" data-testid="footer-admin-login">Admin Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
